import { render, staticRenderFns } from "./InstructorProfileModal.vue?vue&type=template&id=788fae66&scoped=true"
import script from "./InstructorProfileModal.vue?vue&type=script&lang=js"
export * from "./InstructorProfileModal.vue?vue&type=script&lang=js"
import style0 from "./InstructorProfileModal.vue?vue&type=style&index=0&id=788fae66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788fae66",
  null
  
)

export default component.exports